// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wr-8";
export var container = "_wr-0";
export var radioDot = "_wr-5";
export var radioDotSelected = "_wr-6";
export var row = "_wr-1";
export var rowFirst = "_wr-2";
export var rowLast = "_wr-3";
export var rowSelected = "_wr-4";
export var strikethrough = "_wr-7";